import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Any } from "../../google/protobuf/any";
import { ExtensionEventBase } from "./business_events";
import { LegalPrompt } from "./legal_prompt";
import { Lens } from "./lens";
import { OperationalMetricsBundle } from "./operational_metrics";
import { RankingData } from "./ranking";
export const protobufPackage = "com.snap.camerakit.v3";
export interface GetGroupRequest {
    id: string;
    rankingData: RankingData | undefined;
}
export interface GetGroupResponse {
    id: string;
    lenses: Lens[];
}
export interface GetGroupLensRequest {
    lensId: string;
    groupId: string;
}
export interface GetGroupLensResponse {
    lens: Lens | undefined;
    groupId: string;
}
export interface BatchGetGroupLensRequest {
    getRequests: GetGroupLensRequest[];
}
export interface BatchGetGroupLensResponse {
    getResponses: GetGroupLensResponse[];
}
export interface GetPlaceholderConfigRequest {
}
export interface GetPlaceholderConfigResponse {
    configs: {
        [key: string]: string;
    };
}
export interface GetPlaceholderConfigResponse_ConfigsEntry {
    key: string;
    value: string;
}
export interface GetInitializationConfigRequest {
}
export interface GetInitializationConfigResponse {
    appVendorUuidOptIn: boolean;
    watermarkEnabled: boolean;
    childrenProtectionActRestricted: boolean;
    legalPrompt: LegalPrompt | undefined;
}
export interface SetOperationalMetricsRequest {
    metrics: OperationalMetricsBundle | undefined;
}
export interface SetOperationalMetricsResponse {
}
export interface SetBusinessEventsRequest {
    batchEvents: Any | undefined;
}
export interface SetBusinessEventsResponse {
}
export interface SetExtensionBusinessEventsRequest {
    events: Any[];
    extensionEventBase: ExtensionEventBase | undefined;
}
export interface SetExtensionBusinessEventsResponse {
}
function createBaseGetGroupRequest(): GetGroupRequest {
    return { id: "", rankingData: undefined };
}
export const GetGroupRequest: MessageFns<GetGroupRequest> = {
    encode(message: GetGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.rankingData !== undefined) {
            RankingData.encode(message.rankingData, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetGroupRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetGroupRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.rankingData = RankingData.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetGroupRequest>, I>>(base?: I): GetGroupRequest {
        return GetGroupRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetGroupRequest>, I>>(object: I): GetGroupRequest {
        const message = createBaseGetGroupRequest();
        message.id = object.id ?? "";
        message.rankingData = (object.rankingData !== undefined && object.rankingData !== null)
            ? RankingData.fromPartial(object.rankingData)
            : undefined;
        return message;
    },
};
function createBaseGetGroupResponse(): GetGroupResponse {
    return { id: "", lenses: [] };
}
export const GetGroupResponse: MessageFns<GetGroupResponse> = {
    encode(message: GetGroupResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        for (const v of message.lenses) {
            Lens.encode(v!, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetGroupResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetGroupResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.lenses.push(Lens.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetGroupResponse>, I>>(base?: I): GetGroupResponse {
        return GetGroupResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetGroupResponse>, I>>(object: I): GetGroupResponse {
        const message = createBaseGetGroupResponse();
        message.id = object.id ?? "";
        message.lenses = object.lenses?.map((e) => Lens.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetGroupLensRequest(): GetGroupLensRequest {
    return { lensId: "", groupId: "" };
}
export const GetGroupLensRequest: MessageFns<GetGroupLensRequest> = {
    encode(message: GetGroupLensRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.lensId !== "") {
            writer.uint32(10).string(message.lensId);
        }
        if (message.groupId !== "") {
            writer.uint32(18).string(message.groupId);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetGroupLensRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetGroupLensRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.lensId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.groupId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetGroupLensRequest>, I>>(base?: I): GetGroupLensRequest {
        return GetGroupLensRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetGroupLensRequest>, I>>(object: I): GetGroupLensRequest {
        const message = createBaseGetGroupLensRequest();
        message.lensId = object.lensId ?? "";
        message.groupId = object.groupId ?? "";
        return message;
    },
};
function createBaseGetGroupLensResponse(): GetGroupLensResponse {
    return { lens: undefined, groupId: "" };
}
export const GetGroupLensResponse: MessageFns<GetGroupLensResponse> = {
    encode(message: GetGroupLensResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.lens !== undefined) {
            Lens.encode(message.lens, writer.uint32(10).fork()).join();
        }
        if (message.groupId !== "") {
            writer.uint32(18).string(message.groupId);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetGroupLensResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetGroupLensResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.lens = Lens.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.groupId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetGroupLensResponse>, I>>(base?: I): GetGroupLensResponse {
        return GetGroupLensResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetGroupLensResponse>, I>>(object: I): GetGroupLensResponse {
        const message = createBaseGetGroupLensResponse();
        message.lens = (object.lens !== undefined && object.lens !== null) ? Lens.fromPartial(object.lens) : undefined;
        message.groupId = object.groupId ?? "";
        return message;
    },
};
function createBaseBatchGetGroupLensRequest(): BatchGetGroupLensRequest {
    return { getRequests: [] };
}
export const BatchGetGroupLensRequest: MessageFns<BatchGetGroupLensRequest> = {
    encode(message: BatchGetGroupLensRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.getRequests) {
            GetGroupLensRequest.encode(v!, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): BatchGetGroupLensRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchGetGroupLensRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.getRequests.push(GetGroupLensRequest.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<BatchGetGroupLensRequest>, I>>(base?: I): BatchGetGroupLensRequest {
        return BatchGetGroupLensRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<BatchGetGroupLensRequest>, I>>(object: I): BatchGetGroupLensRequest {
        const message = createBaseBatchGetGroupLensRequest();
        message.getRequests = object.getRequests?.map((e) => GetGroupLensRequest.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBatchGetGroupLensResponse(): BatchGetGroupLensResponse {
    return { getResponses: [] };
}
export const BatchGetGroupLensResponse: MessageFns<BatchGetGroupLensResponse> = {
    encode(message: BatchGetGroupLensResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.getResponses) {
            GetGroupLensResponse.encode(v!, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): BatchGetGroupLensResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchGetGroupLensResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.getResponses.push(GetGroupLensResponse.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<BatchGetGroupLensResponse>, I>>(base?: I): BatchGetGroupLensResponse {
        return BatchGetGroupLensResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<BatchGetGroupLensResponse>, I>>(object: I): BatchGetGroupLensResponse {
        const message = createBaseBatchGetGroupLensResponse();
        message.getResponses = object.getResponses?.map((e) => GetGroupLensResponse.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetPlaceholderConfigRequest(): GetPlaceholderConfigRequest {
    return {};
}
export const GetPlaceholderConfigRequest: MessageFns<GetPlaceholderConfigRequest> = {
    encode(_: GetPlaceholderConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetPlaceholderConfigRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPlaceholderConfigRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetPlaceholderConfigRequest>, I>>(base?: I): GetPlaceholderConfigRequest {
        return GetPlaceholderConfigRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetPlaceholderConfigRequest>, I>>(_: I): GetPlaceholderConfigRequest {
        const message = createBaseGetPlaceholderConfigRequest();
        return message;
    },
};
function createBaseGetPlaceholderConfigResponse(): GetPlaceholderConfigResponse {
    return { configs: {} };
}
export const GetPlaceholderConfigResponse: MessageFns<GetPlaceholderConfigResponse> = {
    encode(message: GetPlaceholderConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        Object.entries(message.configs).forEach(([key, value]) => {
            GetPlaceholderConfigResponse_ConfigsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
        });
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetPlaceholderConfigResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPlaceholderConfigResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = GetPlaceholderConfigResponse_ConfigsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.configs[entry1.key] = entry1.value;
                    }
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetPlaceholderConfigResponse>, I>>(base?: I): GetPlaceholderConfigResponse {
        return GetPlaceholderConfigResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetPlaceholderConfigResponse>, I>>(object: I): GetPlaceholderConfigResponse {
        const message = createBaseGetPlaceholderConfigResponse();
        message.configs = Object.entries(object.configs ?? {}).reduce<{
            [key: string]: string;
        }>((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseGetPlaceholderConfigResponse_ConfigsEntry(): GetPlaceholderConfigResponse_ConfigsEntry {
    return { key: "", value: "" };
}
export const GetPlaceholderConfigResponse_ConfigsEntry: MessageFns<GetPlaceholderConfigResponse_ConfigsEntry> = {
    encode(message: GetPlaceholderConfigResponse_ConfigsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetPlaceholderConfigResponse_ConfigsEntry {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPlaceholderConfigResponse_ConfigsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetPlaceholderConfigResponse_ConfigsEntry>, I>>(base?: I): GetPlaceholderConfigResponse_ConfigsEntry {
        return GetPlaceholderConfigResponse_ConfigsEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetPlaceholderConfigResponse_ConfigsEntry>, I>>(object: I): GetPlaceholderConfigResponse_ConfigsEntry {
        const message = createBaseGetPlaceholderConfigResponse_ConfigsEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseGetInitializationConfigRequest(): GetInitializationConfigRequest {
    return {};
}
export const GetInitializationConfigRequest: MessageFns<GetInitializationConfigRequest> = {
    encode(_: GetInitializationConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetInitializationConfigRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetInitializationConfigRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetInitializationConfigRequest>, I>>(base?: I): GetInitializationConfigRequest {
        return GetInitializationConfigRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetInitializationConfigRequest>, I>>(_: I): GetInitializationConfigRequest {
        const message = createBaseGetInitializationConfigRequest();
        return message;
    },
};
function createBaseGetInitializationConfigResponse(): GetInitializationConfigResponse {
    return {
        appVendorUuidOptIn: false,
        watermarkEnabled: false,
        childrenProtectionActRestricted: false,
        legalPrompt: undefined,
    };
}
export const GetInitializationConfigResponse: MessageFns<GetInitializationConfigResponse> = {
    encode(message: GetInitializationConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.appVendorUuidOptIn !== false) {
            writer.uint32(8).bool(message.appVendorUuidOptIn);
        }
        if (message.watermarkEnabled !== false) {
            writer.uint32(16).bool(message.watermarkEnabled);
        }
        if (message.childrenProtectionActRestricted !== false) {
            writer.uint32(24).bool(message.childrenProtectionActRestricted);
        }
        if (message.legalPrompt !== undefined) {
            LegalPrompt.encode(message.legalPrompt, writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): GetInitializationConfigResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetInitializationConfigResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.appVendorUuidOptIn = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.watermarkEnabled = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.childrenProtectionActRestricted = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.legalPrompt = LegalPrompt.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<GetInitializationConfigResponse>, I>>(base?: I): GetInitializationConfigResponse {
        return GetInitializationConfigResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<GetInitializationConfigResponse>, I>>(object: I): GetInitializationConfigResponse {
        const message = createBaseGetInitializationConfigResponse();
        message.appVendorUuidOptIn = object.appVendorUuidOptIn ?? false;
        message.watermarkEnabled = object.watermarkEnabled ?? false;
        message.childrenProtectionActRestricted = object.childrenProtectionActRestricted ?? false;
        message.legalPrompt = (object.legalPrompt !== undefined && object.legalPrompt !== null)
            ? LegalPrompt.fromPartial(object.legalPrompt)
            : undefined;
        return message;
    },
};
function createBaseSetOperationalMetricsRequest(): SetOperationalMetricsRequest {
    return { metrics: undefined };
}
export const SetOperationalMetricsRequest: MessageFns<SetOperationalMetricsRequest> = {
    encode(message: SetOperationalMetricsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.metrics !== undefined) {
            OperationalMetricsBundle.encode(message.metrics, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SetOperationalMetricsRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetOperationalMetricsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.metrics = OperationalMetricsBundle.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SetOperationalMetricsRequest>, I>>(base?: I): SetOperationalMetricsRequest {
        return SetOperationalMetricsRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SetOperationalMetricsRequest>, I>>(object: I): SetOperationalMetricsRequest {
        const message = createBaseSetOperationalMetricsRequest();
        message.metrics = (object.metrics !== undefined && object.metrics !== null)
            ? OperationalMetricsBundle.fromPartial(object.metrics)
            : undefined;
        return message;
    },
};
function createBaseSetOperationalMetricsResponse(): SetOperationalMetricsResponse {
    return {};
}
export const SetOperationalMetricsResponse: MessageFns<SetOperationalMetricsResponse> = {
    encode(_: SetOperationalMetricsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SetOperationalMetricsResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetOperationalMetricsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SetOperationalMetricsResponse>, I>>(base?: I): SetOperationalMetricsResponse {
        return SetOperationalMetricsResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SetOperationalMetricsResponse>, I>>(_: I): SetOperationalMetricsResponse {
        const message = createBaseSetOperationalMetricsResponse();
        return message;
    },
};
function createBaseSetBusinessEventsRequest(): SetBusinessEventsRequest {
    return { batchEvents: undefined };
}
export const SetBusinessEventsRequest: MessageFns<SetBusinessEventsRequest> = {
    encode(message: SetBusinessEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.batchEvents !== undefined) {
            Any.encode(message.batchEvents, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SetBusinessEventsRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetBusinessEventsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.batchEvents = Any.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SetBusinessEventsRequest>, I>>(base?: I): SetBusinessEventsRequest {
        return SetBusinessEventsRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SetBusinessEventsRequest>, I>>(object: I): SetBusinessEventsRequest {
        const message = createBaseSetBusinessEventsRequest();
        message.batchEvents = (object.batchEvents !== undefined && object.batchEvents !== null)
            ? Any.fromPartial(object.batchEvents)
            : undefined;
        return message;
    },
};
function createBaseSetBusinessEventsResponse(): SetBusinessEventsResponse {
    return {};
}
export const SetBusinessEventsResponse: MessageFns<SetBusinessEventsResponse> = {
    encode(_: SetBusinessEventsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SetBusinessEventsResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetBusinessEventsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SetBusinessEventsResponse>, I>>(base?: I): SetBusinessEventsResponse {
        return SetBusinessEventsResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SetBusinessEventsResponse>, I>>(_: I): SetBusinessEventsResponse {
        const message = createBaseSetBusinessEventsResponse();
        return message;
    },
};
function createBaseSetExtensionBusinessEventsRequest(): SetExtensionBusinessEventsRequest {
    return { events: [], extensionEventBase: undefined };
}
export const SetExtensionBusinessEventsRequest: MessageFns<SetExtensionBusinessEventsRequest> = {
    encode(message: SetExtensionBusinessEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.events) {
            Any.encode(v!, writer.uint32(10).fork()).join();
        }
        if (message.extensionEventBase !== undefined) {
            ExtensionEventBase.encode(message.extensionEventBase, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SetExtensionBusinessEventsRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetExtensionBusinessEventsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.events.push(Any.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.extensionEventBase = ExtensionEventBase.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SetExtensionBusinessEventsRequest>, I>>(base?: I): SetExtensionBusinessEventsRequest {
        return SetExtensionBusinessEventsRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SetExtensionBusinessEventsRequest>, I>>(object: I): SetExtensionBusinessEventsRequest {
        const message = createBaseSetExtensionBusinessEventsRequest();
        message.events = object.events?.map((e) => Any.fromPartial(e)) || [];
        message.extensionEventBase = (object.extensionEventBase !== undefined && object.extensionEventBase !== null)
            ? ExtensionEventBase.fromPartial(object.extensionEventBase)
            : undefined;
        return message;
    },
};
function createBaseSetExtensionBusinessEventsResponse(): SetExtensionBusinessEventsResponse {
    return {};
}
export const SetExtensionBusinessEventsResponse: MessageFns<SetExtensionBusinessEventsResponse> = {
    encode(_: SetExtensionBusinessEventsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): SetExtensionBusinessEventsResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetExtensionBusinessEventsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<SetExtensionBusinessEventsResponse>, I>>(base?: I): SetExtensionBusinessEventsResponse {
        return SetExtensionBusinessEventsResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<SetExtensionBusinessEventsResponse>, I>>(_: I): SetExtensionBusinessEventsResponse {
        const message = createBaseSetExtensionBusinessEventsResponse();
        return message;
    },
};
export type LensesDefinition = typeof LensesDefinition;
export const LensesDefinition = {
    name: "Lenses",
    fullName: "com.snap.camerakit.v3.Lenses",
    methods: {
        getGroup: {
            name: "GetGroup",
            requestType: GetGroupRequest,
            requestStream: false,
            responseType: GetGroupResponse,
            responseStream: false,
            options: {
                idempotencyLevel: "NO_SIDE_EFFECTS",
                _unknownFields: {
                    578365826: [
                        new Uint8Array([
                            43,
                            18,
                            41,
                            47,
                            99,
                            111,
                            109,
                            46,
                            115,
                            110,
                            97,
                            112,
                            46,
                            99,
                            97,
                            109,
                            101,
                            114,
                            97,
                            107,
                            105,
                            116,
                            46,
                            118,
                            51,
                            46,
                            76,
                            101,
                            110,
                            115,
                            101,
                            115,
                            47,
                            103,
                            114,
                            111,
                            117,
                            112,
                            115,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                    ],
                },
            },
        },
        getGroupLens: {
            name: "GetGroupLens",
            requestType: GetGroupLensRequest,
            requestStream: false,
            responseType: GetGroupLensResponse,
            responseStream: false,
            options: {
                idempotencyLevel: "NO_SIDE_EFFECTS",
                _unknownFields: {
                    578365826: [
                        new Uint8Array([
                            66,
                            18,
                            64,
                            47,
                            99,
                            111,
                            109,
                            46,
                            115,
                            110,
                            97,
                            112,
                            46,
                            99,
                            97,
                            109,
                            101,
                            114,
                            97,
                            107,
                            105,
                            116,
                            46,
                            118,
                            51,
                            46,
                            76,
                            101,
                            110,
                            115,
                            101,
                            115,
                            47,
                            103,
                            114,
                            111,
                            117,
                            112,
                            115,
                            47,
                            123,
                            103,
                            114,
                            111,
                            117,
                            112,
                            95,
                            105,
                            100,
                            125,
                            47,
                            108,
                            101,
                            110,
                            115,
                            101,
                            115,
                            47,
                            123,
                            108,
                            101,
                            110,
                            115,
                            95,
                            105,
                            100,
                            125,
                        ]),
                    ],
                },
            },
        },
        batchGetGroupLens: {
            name: "BatchGetGroupLens",
            requestType: BatchGetGroupLensRequest,
            requestStream: false,
            responseType: BatchGetGroupLensResponse,
            responseStream: false,
            options: {
                idempotencyLevel: "NO_SIDE_EFFECTS",
                _unknownFields: {
                    578365826: [
                        new Uint8Array([
                            58,
                            34,
                            53,
                            47,
                            99,
                            111,
                            109,
                            46,
                            115,
                            110,
                            97,
                            112,
                            46,
                            99,
                            97,
                            109,
                            101,
                            114,
                            97,
                            107,
                            105,
                            116,
                            46,
                            118,
                            51,
                            46,
                            76,
                            101,
                            110,
                            115,
                            101,
                            115,
                            47,
                            103,
                            114,
                            111,
                            117,
                            112,
                            115,
                            95,
                            108,
                            101,
                            110,
                            115,
                            101,
                            115,
                            47,
                            98,
                            97,
                            116,
                            99,
                            104,
                            95,
                            103,
                            101,
                            116,
                            58,
                            1,
                            42,
                        ]),
                    ],
                },
            },
        },
        getPlaceholderConfig: {
            name: "GetPlaceholderConfig",
            requestType: GetPlaceholderConfigRequest,
            requestStream: false,
            responseType: GetPlaceholderConfigResponse,
            responseStream: false,
            options: {
                idempotencyLevel: "NO_SIDE_EFFECTS",
                _unknownFields: {
                    578365826: [
                        new Uint8Array([
                            50,
                            18,
                            48,
                            47,
                            99,
                            111,
                            109,
                            46,
                            115,
                            110,
                            97,
                            112,
                            46,
                            99,
                            97,
                            109,
                            101,
                            114,
                            97,
                            107,
                            105,
                            116,
                            46,
                            118,
                            51,
                            46,
                            76,
                            101,
                            110,
                            115,
                            101,
                            115,
                            47,
                            112,
                            108,
                            97,
                            99,
                            101,
                            104,
                            111,
                            108,
                            100,
                            101,
                            114,
                            95,
                            99,
                            111,
                            110,
                            102,
                            105,
                            103,
                        ]),
                    ],
                },
            },
        },
    },
} as const;
export type MetricsDefinition = typeof MetricsDefinition;
export const MetricsDefinition = {
    name: "Metrics",
    fullName: "com.snap.camerakit.v3.Metrics",
    methods: {
        setOperationalMetrics: {
            name: "SetOperationalMetrics",
            requestType: SetOperationalMetricsRequest,
            requestStream: false,
            responseType: SetOperationalMetricsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    578365826: [
                        new Uint8Array([
                            63,
                            34,
                            58,
                            47,
                            99,
                            111,
                            109,
                            46,
                            115,
                            110,
                            97,
                            112,
                            46,
                            99,
                            97,
                            109,
                            101,
                            114,
                            97,
                            107,
                            105,
                            116,
                            46,
                            118,
                            51,
                            46,
                            77,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            47,
                            109,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            47,
                            111,
                            112,
                            101,
                            114,
                            97,
                            116,
                            105,
                            111,
                            110,
                            97,
                            108,
                            95,
                            109,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            58,
                            1,
                            42,
                        ]),
                    ],
                },
            },
        },
        setBusinessEvents: {
            name: "SetBusinessEvents",
            requestType: SetBusinessEventsRequest,
            requestStream: false,
            responseType: SetBusinessEventsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    578365826: [
                        new Uint8Array([
                            59,
                            34,
                            54,
                            47,
                            99,
                            111,
                            109,
                            46,
                            115,
                            110,
                            97,
                            112,
                            46,
                            99,
                            97,
                            109,
                            101,
                            114,
                            97,
                            107,
                            105,
                            116,
                            46,
                            118,
                            51,
                            46,
                            77,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            47,
                            109,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            47,
                            98,
                            117,
                            115,
                            105,
                            110,
                            101,
                            115,
                            115,
                            95,
                            101,
                            118,
                            101,
                            110,
                            116,
                            115,
                            58,
                            1,
                            42,
                        ]),
                    ],
                },
            },
        },
        setExtensionBusinessEvents: {
            name: "SetExtensionBusinessEvents",
            requestType: SetExtensionBusinessEventsRequest,
            requestStream: false,
            responseType: SetExtensionBusinessEventsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    578365826: [
                        new Uint8Array([
                            69,
                            34,
                            64,
                            47,
                            99,
                            111,
                            109,
                            46,
                            115,
                            110,
                            97,
                            112,
                            46,
                            99,
                            97,
                            109,
                            101,
                            114,
                            97,
                            107,
                            105,
                            116,
                            46,
                            118,
                            51,
                            46,
                            77,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            47,
                            109,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            47,
                            101,
                            120,
                            116,
                            101,
                            110,
                            115,
                            105,
                            111,
                            110,
                            95,
                            98,
                            117,
                            115,
                            105,
                            110,
                            101,
                            115,
                            115,
                            95,
                            101,
                            118,
                            101,
                            110,
                            116,
                            115,
                            58,
                            1,
                            42,
                        ]),
                    ],
                },
            },
        },
        getInitializationConfig: {
            name: "GetInitializationConfig",
            requestType: GetInitializationConfigRequest,
            requestStream: false,
            responseType: GetInitializationConfigResponse,
            responseStream: false,
            options: {
                idempotencyLevel: "NO_SIDE_EFFECTS",
                _unknownFields: {
                    578365826: [
                        new Uint8Array([
                            62,
                            18,
                            60,
                            47,
                            99,
                            111,
                            109,
                            46,
                            115,
                            110,
                            97,
                            112,
                            46,
                            99,
                            97,
                            109,
                            101,
                            114,
                            97,
                            107,
                            105,
                            116,
                            46,
                            118,
                            51,
                            46,
                            77,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            47,
                            109,
                            101,
                            116,
                            114,
                            105,
                            99,
                            115,
                            47,
                            105,
                            110,
                            105,
                            116,
                            105,
                            97,
                            108,
                            105,
                            122,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            99,
                            111,
                            110,
                            102,
                            105,
                            103,
                        ]),
                    ],
                },
            },
        },
    },
} as const;
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {
    $case: string;
} ? {
    [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]>;
} & {
    $case: T["$case"];
} : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
